// Pure model (10/08/2026, Josh): what a dashboard row can DO when expanded. Returns an "action plan" for a
// notification-feed item or a Needs-Attention row; the component renders buttons from it and runs the side effects.
//
// plan = { kind, dealId, email: {kind, roles[]} | null, candidatesJob | null, href | null, importDate | null, importBatch | null }

const titleHas = (it, s) => (it.title || '').toLowerCase().includes(s);

export const planForFeedItem = (it) => {
  if (!it) return null;
  if (it.kind === 'upload') {
    const day = (it.at || '').slice(0, 10) || null;
    return { kind: 'upload', dealId: null, email: null, candidatesJob: null,
      href: `/daily-import-review${day ? `?date=${day}` : ''}${it.id ? `${day ? '&' : '?'}batch=${it.id}` : ''}`,
      importDate: day, importBatch: it.id || null };
  }
  const n = it.raw || {};
  const dealId = n.entity_type === 'deal' ? n.entity_id : null;
  const t = (n.type || '').toLowerCase();
  if (t === 'reminder_due') return { kind: 'reminder', dealId, email: null, candidatesJob: null, href: it.href || '/notifications' };
  if (t === 'deal_paid_off') return { kind: 'paid_off', dealId, email: null, candidatesJob: null, href: it.href };
  // 10/23: merchant signed / asked for a correction → straight to the deal's Confirmation tab
  if (t === 'funding_confirmation') return { kind: 'funding_confirmation', dealId, email: null, candidatesJob: null, href: it.href || (dealId ? `/deals/${dealId}?tab=confirmation` : null) };
  if (t === 'stage_change') return { kind: 'stage_change', dealId, email: null, candidatesJob: null, href: it.href };
  if (titleHas(it, 'missed payment')) return { kind: 'missed_payment', dealId, email: dealId ? { kind: 'missed_payment', roles: ['merchant', 'broker'] } : null, candidatesJob: dealId ? null : 'missed_payment_detector', href: it.href };
  if (titleHas(it, 'bounce streak')) return { kind: 'bounce_streak', dealId, email: dealId ? { kind: 'bounce', roles: ['broker'] } : null, candidatesJob: null, href: it.href };
  if (titleHas(it, 'of payoff')) return { kind: 'payoff', dealId, email: dealId ? { kind: 'payoff', roles: ['merchant', 'broker'] } : null, candidatesJob: 'payoff_approaching', href: null };
  if (titleHas(it, 'renewal candidate')) return { kind: 'renewal', dealId, email: dealId ? { kind: 'renewal', roles: ['merchant', 'broker'] } : null, candidatesJob: 'renewal_window', href: null };
  if (titleHas(it, 'stale deal')) return { kind: 'stale', dealId, email: dealId ? { kind: 'stale', roles: ['merchant', 'broker'] } : null, candidatesJob: 'stale_deal_nudge', href: null };
  if (titleHas(it, 'reconciliation')) {
    const m = /(\d{1,2})\/(\d{1,2})/.exec(it.title || '');
    const year = new Date(it.at || Date.now()).getFullYear();
    const day = m ? `${year}-${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}` : null;
    return { kind: 'reconciliation', dealId: null, email: null, candidatesJob: null, href: `/daily-import-review${day ? `?date=${day}` : ''}`, importDate: day };
  }
  return { kind: 'generic', dealId, email: null, candidatesJob: null, href: it.href || (dealId ? `/deals/${dealId}` : null) };
};

// Needs Attention row → which outreach wording fits the reason.
export const planForAttention = (n) => {
  if (!n) return null;
  const why = (n.reasons || []).join(' ').toLowerCase();
  const dealId = n.deal_id;
  if (why.includes('zero balance')) return { kind: 'zero_balance', dealId, email: null, candidatesJob: null, href: `/deals/${dealId}` };
  let kind = 'stale';
  if (why.includes('matured')) kind = 'matured';
  else if (why.includes('last payment') || why.includes('no payments')) kind = 'missed_payment';
  return { kind, dealId, email: { kind, roles: ['merchant', 'broker'] }, candidatesJob: null, href: `/deals/${dealId}` };
};

export const EMAIL_LABEL = {
  renewal: 'renewal offer',
  payoff: 'payoff / EPO note',
  missed_payment: 'missed-payment notice',
  matured: 'matured-balance notice',
  stale: 'check-in',
  bounce: 'bounce notice',
};
